import momentTz from 'moment-timezone';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';

export const useDateByUserTimezone = () => {
  const userTimezone = useSelector((state) =>
    _get(state, 'auth.user.timezone.time', momentTz.tz.guess())
  );

  const getDateByUserTimezone = ({ dateString, dateFormat, shouldFormat = true }) => {
    if (!dateString) return '-';

    return shouldFormat
      ? momentTz(dateString)
          .tz(userTimezone)
          ?.format(dateFormat || 'YYYY-MM-DD HH:mm:ss')
      : momentTz(dateString).tz(userTimezone);
  };

  return { getDateByUserTimezone };
};
